import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController} from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-recommendation-thank-you-popover',
  templateUrl: 'recommendation-thank-you-popover.html',
})
export class RecommendationThankYouPopoverPage {

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
  ) {
  }

  closePopover() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/recommendation-thank-you-popover/recommendation-thank-you-popover.ts